import { Column } from "@tanstack/react-table";

import { Checkbox } from "src/base-components/Checkbox";
import { HighlightedText } from "src/base-components/HighlightedText";
import { Pill } from "src/base-components/Pill";
import {
  INTERMEDIATE_TABLE_PREFIXES,
  RESULT_COLUMN_PREFIX,
} from "src/dataTable/TablePrefixes";
import { ResultDataAndAuxRowV2 } from "src/dataTable/types";
import { useAuthoringContext } from "src/router/routerContextHooks";

const getNameFromColumnId = (id: string) => {
  const prefix = INTERMEDIATE_TABLE_PREFIXES.find((prefix) =>
    id.startsWith(prefix),
  );

  return prefix ? id.slice(prefix.length) : id;
};

type Props = {
  column: Column<ResultDataAndAuxRowV2>;
  query: string;
  ref?: React.Ref<HTMLLabelElement>;
};

export const ResultColumnSelectorRow: React.FC<Props> = ({
  column,
  query,
  ref,
}) => {
  const { version } = useAuthoringContext();

  const columnName = getNameFromColumnId(column.id);

  const isResultColumn = column.id.startsWith(RESULT_COLUMN_PREFIX);
  const isInputSchemaColumn =
    isResultColumn &&
    Object.keys(version.input_schema?.properties ?? {}).includes(columnName);

  return (
    <label
      ref={ref}
      className="flex h-12 w-full cursor-pointer items-center gap-x-2 px-4"
      data-loc={`select-${columnName}`}
    >
      <Checkbox
        checked={column.getIsVisible()}
        onChange={() => column.toggleVisibility()}
      />
      <p className="truncate font-inter-normal-13px text-gray-800">
        <HighlightedText
          highlight={query}
          highlightClassName="font-inter-semibold-13px"
          text={columnName}
        />
      </p>
      {isInputSchemaColumn && (
        <Pill fontType="code" size="sm" variant="gray">
          <Pill.Text>{"{}"}</Pill.Text>
        </Pill>
      )}
    </label>
  );
};
